var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{attrs:{"color":"grey","label":_vm.label,"disable":_vm.deleting},on:{"click":_vm.del}})
}
var staticRenderFns = []

export { render, staticRenderFns }